"use client";

import { Typography } from "@material-tailwind/react";
import ProjectCard, { ProjectCardProps } from "./ProjectCard";
import { useEffect, useState } from "react";
import blogApi from "@/api/blog";

export function Projects() {
  const [blogs, setBlogs] = useState<ProjectCardProps[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getBlogs();
  }, []);

  const getBlogs = async () => {
    try {
      setIsLoading(true);
      const data = await blogApi.list({});
      setBlogs(data.blogs);
    } catch {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="py-28 px-8" id="products">
      <div className="container mx-auto mb-20 text-center">
        <Typography variant="h2" color="blue-gray" className="mb-4 font-noto">
          สินค้าประกัน 3 รายการล่าสุด
        </Typography>
      </div>
      {!isLoading && (
        <div className="container mx-auto grid grid-cols-1 gap-x-10 gap-y-20 md:grid-cols-2 xl:grid-cols-4">
          {blogs.map((props, idx) => (
            <ProjectCard key={idx} {...props} />
          ))}
        </div>
      )}
    </section>
  );
}

export default Projects;
